import type { ConnectedPosition } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

import type {
  HeadingMenuController,
  HeadingMenuOpenData,
  OverlayPosition,
} from '@core/prosemirror-legacy';
import { WysiwygComponentPortalService } from '@core/prosemirror-legacy/angular';

import { HeadingMenuComponent } from './heading-menu.component';

@Injectable()
export class HeadingMenuService
  extends WysiwygComponentPortalService<HeadingMenuComponent>
  implements HeadingMenuController
{
  protected overlayConfig = {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
  };

  public open(position: OverlayPosition | DOMRect, data: HeadingMenuOpenData) {
    const preferredPositions: ConnectedPosition[] = [
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    ];
    this.close();
    this.openComponent(HeadingMenuComponent, position, preferredPositions, {
      skipComponentCD: true,
    });
    const { instance, location } = this.componentRef!;
    instance.close = () => {
      this.close();
    };
    instance.select = data.onSelect;
    instance.initialLevel = data.initialLevel;
    this.componentRef?.changeDetectorRef.detectChanges();
    return {
      element: <HTMLElement>location.nativeElement,
      backdropClick$: this.overlayRef!.backdropClick(),
    };
  }

  public setSelectCallback(selectCb: (val: { level: number }) => void): void {
    if (!this.componentRef) return;
    this.componentRef.instance.select = selectCb;
  }
}
